































































import Vue from 'vue'
import { AppMixin } from '~/node_modules/sitis-nuxt/lib/mixins/index'
import BaseCmsBlock from '../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin'
import { ObserveVisibility } from 'vue-observe-visibility'

import StoresFull from './stores/StoresFull.vue'
import StoresHome from './stores/StoresHome.vue'

export default BaseCmsBlock.extend({
  name: 'StoresBlock',

  components: {
    StoresHome,
    StoresFull
  },
  mixins: [
    AppMixin
  ],
  data: function () {
    const {
      extras,
      values
    } = this
    const cities = extras.cities
    const stores = extras.stores

    return {
      cities: cities,
      stores: stores,
      activeCity: cities['1']?.id || '',
      activeShop: '',
      searchStore: '',
      yandexMapCoords: [56.838011, 60.597465],
      type: values.type,
      isReady: false
    }
  },
  directives: {
    ObserveVisibility
  },
  mounted () {
    const activeCityName = this.appCfg?.city?.model?.name || 'Екатеринбург'
    let activeCityId = this.cities[Object.keys(this.cities).find((t) => this.cities[t]?.city_name === activeCityName)]?.id || 1

    if (!activeCityId) {
      activeCityId = 1
    }

    this.activeCity = activeCityId
  },
  computed: {
    getHost () {
      return this.$store.getters['local-settings/currentHost']
    },
    getStores: function () {
      return this.stores.filter((t) => {
        if (
          String(t.city_id) === String(this.activeCity) &&
          t.address.toLowerCase().indexOf(this.searchStore.toLowerCase()) > -1
        ) {
          return t
        }
      })
    }
  },
  methods: {
    setCity: function (id) {
      this.activeCity = id
      this.activeShop = ''
    },
    setStore: function (id) {
      this.activeShop = (this.activeShop === id) ? '' : id
      this.onScrollActiveShop(id)
    },
    onChangeSearch: function ({ target }) {
      this.searchStore = target.value
    },
    onScrollActiveShop (shopId) {
      const container = document.getElementById(`container-shops-block`)
      const activeShop = document.getElementById(`store${shopId}`)
      const containerScrollPositionTop = container.offsetTop
      const itemScrollPositionTop = activeShop.offsetTop

      container.scrollTo({
        top: (itemScrollPositionTop - containerScrollPositionTop),
        behavior: 'smooth'
      })
    }
  }
})
